/**
 * Contract Manager API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';

import {Observable} from 'rxjs';

import {MailItemAttachment} from '../model/mailItemAttachment';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class MailItemAttachmentService {

  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  protected basePath = 'https://localhost';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Removes the MailItemAttachment resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteMailItemAttachmentItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;

  public deleteMailItemAttachmentItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;

  public deleteMailItemAttachmentItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;

  public deleteMailItemAttachmentItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteMailItemAttachmentItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.delete<any>(`${this.basePath}/api/mail_item_attachments/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves the collection of MailItemAttachment resources.
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMailItemAttachmentCollection(observe?: 'body', reportProgress?: boolean): Observable<Array<MailItemAttachment>>;

  public getMailItemAttachmentCollection(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<MailItemAttachment>>>;

  public getMailItemAttachmentCollection(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<MailItemAttachment>>>;

  public getMailItemAttachmentCollection(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<Array<MailItemAttachment>>(`${this.basePath}/api/mail_item_attachments`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Retrieves a MailItemAttachment resource.
   *
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMailItemAttachmentItem(id: string, observe?: 'body', reportProgress?: boolean): Observable<MailItemAttachment>;

  public getMailItemAttachmentItem(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MailItemAttachment>>;

  public getMailItemAttachmentItem(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MailItemAttachment>>;

  public getMailItemAttachmentItem(id: string, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getMailItemAttachmentItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [];

    return this.httpClient.get<MailItemAttachment>(`${this.basePath}/api/mail_item_attachments/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a MailItemAttachment resource.
   *
   * @param mailItemAttachment The new MailItemAttachment resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postMailItemAttachmentCollection(mailItemAttachment?: MailItemAttachment, observe?: 'body', reportProgress?: boolean): Observable<MailItemAttachment>;

  public postMailItemAttachmentCollection(mailItemAttachment?: MailItemAttachment, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MailItemAttachment>>;

  public postMailItemAttachmentCollection(mailItemAttachment?: MailItemAttachment, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MailItemAttachment>>;

  public postMailItemAttachmentCollection(mailItemAttachment?: MailItemAttachment, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<MailItemAttachment>(`${this.basePath}/api/mail_item_attachments`,
      mailItemAttachment,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Replaces the MailItemAttachment resource.
   *
   * @param id
   * @param mailItemAttachment The updated MailItemAttachment resource
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putMailItemAttachmentItem(id: string, mailItemAttachment?: MailItemAttachment, observe?: 'body', reportProgress?: boolean): Observable<MailItemAttachment>;

  public putMailItemAttachmentItem(id: string, mailItemAttachment?: MailItemAttachment, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MailItemAttachment>>;

  public putMailItemAttachmentItem(id: string, mailItemAttachment?: MailItemAttachment, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MailItemAttachment>>;

  public putMailItemAttachmentItem(id: string, mailItemAttachment?: MailItemAttachment, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling putMailItemAttachmentItem.');
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
      'application/ld+json',
      'application/hal+json',
      'application/json',
      'text/html'
    ];
    let httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<MailItemAttachment>(`${this.basePath}/api/mail_item_attachments/${encodeURIComponent(String(id))}`,
      mailItemAttachment,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

}
